/**
 * TikTok Ads loader
 */

// #if process.env.TIER === 'premium'
if (pmw.canLoadPremiumFeatures()) {
	require("./adapter")
	require("./functions_premium")
	require("./event_listeners_premium")
}
// #endif

